import styled from "styled-components"
import PaywallTriggerWrapper from "../Paywall/WebViewPaywallTrigerer"

const FixedActionButtonWrapper = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  display: flex;
  width: 56px;
  height: 56px;
  justify-content: center;
  align-items: center;
  gap: 8px;

  border-radius: 100px;
  background: #2cccd3;
  box-shadow: 2px 4px 16px 0px rgba(2, 118, 133, 0.23),
    2px 2px 8px 0px rgba(0, 0, 0, 0.08);
  z-index: var(--z-index-footer-actions);

  @media (min-width: 450px) {
    left: calc(50% + 146px);
  }
`

const Icon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
    >
      <path
        d="M11.4995 9.83203C10.1188 9.83203 8.99951 10.8333 8.99951 12.0685C8.99951 12.3367 9.05226 12.5938 9.14898 12.832H13.85C13.9468 12.5938 13.9995 12.3367 13.9995 12.0685C13.9995 10.8333 12.8802 9.83203 11.4995 9.83203Z"
        stroke="#05050C"
        strokeWidth="1.5"
      />
      <path
        d="M21.9995 12.834C21.9995 10.6248 20.1341 8.83398 17.8331 8.83398C17.1751 8.83398 16.5528 8.98041 15.9995 9.24117"
        stroke="#05050C"
        strokeWidth="1.5"
      />
      <path
        d="M11.4995 6.83301C8.46195 6.83301 5.99951 9.5193 5.99951 12.833H16.9995C16.9995 9.5193 14.5371 6.83301 11.4995 6.83301Z"
        stroke="#05050C"
        strokeWidth="1.5"
      />
      <path
        d="M3.5121 12.8507L3.49951 12.835M3.49951 12.835C3.26787 12.8664 3.05748 12.9613 2.85636 13.0803C2.65525 13.1993 2.48008 13.3573 2.34123 13.5451C2.20238 13.7328 2.10266 13.9465 2.04799 14.1734C1.99331 14.4003 1.98479 14.6359 2.02292 14.8662C2.81296 19.6109 4.81856 21.7814 7.93327 23.0448V24.2174C7.93327 24.9116 8.2095 25.5774 8.70118 26.0683C9.19287 26.5592 9.85973 26.835 10.5551 26.835H17.5466C18.2419 26.835 18.9088 26.5592 19.4005 26.0683C19.8921 25.5774 20.1684 24.9116 20.1684 24.2174V23.0448C23.2831 21.7814 25.1857 19.6109 25.9758 14.8662C26.0152 14.6296 26.0054 14.3875 25.947 14.1549C25.8885 13.9223 25.7827 13.7042 25.6361 13.5143C25.4894 13.3243 25.3052 13.1666 25.0948 13.0509C24.8844 12.9352 24.6523 12.8641 24.4132 12.8419L22.6286 12.835H20.7566H17.4951H15.7472H13.9993H8.75572H7.00785H5.25998H3.49951Z"
        stroke="#05050C"
        strokeWidth="1.5"
      />
      <path
        d="M23.9168 9.16699V1.00033M19.8335 5.08366L28.0002 5.08366"
        stroke="#05050C"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

const FixedActionButton = ({
  onOpenActionsModal,
  shouldShowPaywallInWebView,
  checkToShowPaywallWhenOpeningActions,
}: {
  onOpenActionsModal: () => void
  shouldShowPaywallInWebView: boolean
  checkToShowPaywallWhenOpeningActions: () => boolean
}) => {
  const checkToOpenActionsModal = () => {
    const shouldShowPaywall = checkToShowPaywallWhenOpeningActions()
    if (shouldShowPaywall) {
      return
    }
    onOpenActionsModal()
  }

  if (shouldShowPaywallInWebView) {
    return (
      <PaywallTriggerWrapper isCheckingAIScan>
        <FixedActionButtonWrapper onClick={checkToOpenActionsModal}>
          <Icon />
        </FixedActionButtonWrapper>
      </PaywallTriggerWrapper>
    )
  }
  return (
    <FixedActionButtonWrapper onClick={checkToOpenActionsModal}>
      <Icon />
    </FixedActionButtonWrapper>
  )
}

export default FixedActionButton
